import { memo, useCallback, useContext, useState } from 'react'
import { SeriesGroup } from '../../../chart.typings'
import BookmarksOutlinedIcon from '@mui/icons-material/BookmarksOutlined'
import { ListItem, ListItemIcon, ListItemText } from '@mui/material'
import { ChartContext } from '../../../chart.context'
import { getExchangeAndCodeFromKey } from '../../../../../util/security'
import ExpressionNameDialog from '../../../../watchlist/expressionNameDialog'
import { v4 as uuid } from 'uuid'
import { useDispatch } from 'react-redux'
import { renameSecurityExpression, saveSecurityExpression } from '../../../../../services/apis/expression'
import { addOrUpdateUserExpression } from '../../../../../reducer/security.reducer'
import commonActions from '../../../../../actions/common.actions'
import { Security } from '../../../../../proto/generated/security'

export type SaveExpressionProps = {
    seriesGroup: SeriesGroup
    onClosed: Function
}

const SaveExpressionMenuItem = (props: SaveExpressionProps) => {
    const { seriesGroup, onClosed } = props
    const chartContext = useContext(ChartContext)
    const expression = chartContext?.chart?.mode !== 'EXPRESSION' ? seriesGroup.securityList[0] : chartContext?.chart?.expression
    const dispatch = useDispatch()
    const [openExpressionNameDialog, setOpenExpressionNameDialog] = useState<boolean>(false)

    const onExpressionNameDialogClosed = useCallback((name: string | null, existingExpressionId?: string) => {
        setOpenExpressionNameDialog(false)
        if (name !== null) {
            if (existingExpressionId) {
                renameSecurityExpression({ expressionId: existingExpressionId, name: name }).then((response) => {
                    dispatch(addOrUpdateUserExpression(response))
                })
            } else {
                saveSecurityExpression({
                    expression: {
                        expression: expression,
                        name: name,
                        securities: seriesGroup.securityList.map((securityKey) => {
                            const exchangeAndCode = getExchangeAndCodeFromKey(securityKey)
                            return {
                                exchange: exchangeAndCode[0],
                                code: exchangeAndCode[1]
                            }
                        }) as Security[],
                        expired: false,
                        id: uuid()
                    }
                }).then((response) => {
                    dispatch(addOrUpdateUserExpression(response))
                    commonActions.deleteRecentExpression(dispatch, response.expression)
                })
            }
        }
        onClosed()

    }, [expression, seriesGroup, onClosed])

    const handleOnSaveClick = () => {
        setOpenExpressionNameDialog(true)
    }

    return (
        <>
            <ListItem onClick={handleOnSaveClick} disablePadding>
                <ListItemIcon> <BookmarksOutlinedIcon /> </ListItemIcon>
                <ListItemText>Save Expression</ListItemText>
            </ListItem>
            {openExpressionNameDialog &&
                <ExpressionNameDialog onClosed={onExpressionNameDialogClosed} showGivenNames={true}
                                      expression={expression} />}
        </>
    )
}

export default memo(SaveExpressionMenuItem)
